import {
  AgentThreadStatus,
  isActiveThreadStatus,
} from "@/shared/domain/agentThread";
import {
  Badge,
  Spinner,
  type BadgeVariant,
} from "@/shared/foundation/primitives";

interface ThreadStatusBadgeProps {
  status: AgentThreadStatus;
}

const STATUS_DISPLAY: Record<
  AgentThreadStatus,
  { label: string; variant: BadgeVariant }
> = {
  [AgentThreadStatus.NOT_STARTED]: {
    label: "Not started",
    variant: "secondary",
  },
  [AgentThreadStatus.USER_TURN]: { label: "User turn", variant: "success" },
  [AgentThreadStatus.ROBOTO_TURN]: { label: "Working", variant: "info" },
  [AgentThreadStatus.CLIENT_TOOL_TURN]: {
    label: "Client tools",
    variant: "warning",
  },
  [AgentThreadStatus.GOALS_FAILED]: { label: "Goals failed", variant: "error" },
};

/**
 * A thread's status as a badge. A thread still working carries a spinner,
 * hidden from assistive tech: the label already says it is working.
 */
export function ThreadStatusBadge({ status }: ThreadStatusBadgeProps) {
  const display = STATUS_DISPLAY[status];
  return (
    <Badge
      variant={display.variant}
      icon={isActiveThreadStatus(status) ? <Spinner aria-hidden /> : undefined}
    >
      {display.label}
    </Badge>
  );
}
